<template>
  <div class="container py-10">
    <div v-if="computedSubmissionDetails" class="flex flex-wrap -mx-10">
      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Project Information</h2>
        <edit-project-info v-if="computedSubmissionDetails.revisedProject" class="mb-3" :project.sync="computedSubmissionDetails.revisedProject" />
      </div>

      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Transaction Information</h2>
        <d-field label="Amount">
          <d-input v-model="computedAmount" type="number" />
        </d-field>
        <d-field label="Billing Company Name">
          <d-input v-model="computedTransactionDetails.companyName" />
        </d-field>
        <d-field label="Billing Address Line 1">
          <d-input v-model="computedTransactionDetails.billingAddress1" />
        </d-field>
        <d-field label="Billing Address Line 2">
          <d-input v-model="computedTransactionDetails.billingAddress2" />
        </d-field>
        <d-field label="Billing City">
          <d-input v-model="computedTransactionDetails.billingCity" />
        </d-field>
        <d-field label="Billing State/Province">
          <d-input v-model="computedTransactionDetails.billingStateProvince" />
        </d-field>
        <d-field label="Billing Zip">
          <d-input v-model="computedTransactionDetails.billingZip" />
        </d-field>
        <d-field label="Billing Email">
          <d-input v-model="computedTransactionDetails.billingEmail" type="email" />
        </d-field>
        <d-field label="Billing Phone">
          <d-input v-model="computedTransactionDetails.billingPhone" />
        </d-field>
      </div>

      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Woodworker Information</h2>
        <edit-organization-info v-if="computedSubmissionDetails.revisedWoodworkerCompany" class="mb-3" :organization.sync="computedSubmissionDetails.revisedWoodworkerCompany" />
      </div>
    </div>
  </div>
</template>

<script>
  import EditOrganizationInfo from '@resources/scripts/patterns/formPatterns/EditOrganizationInfo.vue';
  import EditProjectInfo from '@resources/scripts/patterns/formPatterns/EditProjectInfo.vue';

  export default {
    components: {
      EditOrganizationInfo,
      EditProjectInfo,
    },

    props: {
      submissionDetails: {
        type: Object,
        default: () => ({}),
      },

      transactionDetails: {
        type: Object,
        default: () => ({}),
      },
    },

    computed: {
      computedTransactionDetails: {
        get() {
          return this.transactionDetails;
        },
        set(value) {
          this.$emit('update:transactionDetails', value);
        },
      },

      computedSubmissionDetails: {
        get() {
          return this.submissionDetails;
        },
        set(value) {
          this.$emit('submissionDetails:update', value);
        },
      },

      computedAmount: {
        get() {
          return this.computedTransactionDetails.amount;
        },
        set(value) {
          this.computedTransactionDetails.amount = Number.parseInt(value, 10);
        },
      },
    },
  };
</script>